import { render, staticRenderFns } from "./AgentpayProcess.vue?vue&type=template&id=0f1c60b4&"
import script from "./AgentpayProcess.vue?vue&type=script&lang=js&"
export * from "./AgentpayProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports